import React from 'react'
import PostPages from './PostsPages'

function index() {
  return (
    <>
      <PostPages />
    </>
  )
}

export default index
